import { CONFIGURE_MASK, DIRECT_ACCESS_GPIO_FORMAT } from './definitions';

const ASCENDING_SORT_NUMBER = (a: number, b: number) => a - b;

// export function encodeGPIOWriteConfig(options: GPIOWriteConfig) {
//     if (options.indexs.length === 0) {
//         throw new Error(`Invalid GPIO config. You must give at least one pin index`);
//     }
//     const indexes = options.indexs.sort();
//     const data = encodeMultiGPIOData(indexes, options.mode);
//     return {
//         data,
//         info: encodeMultiAddressInfo(indexes, true)
//     };
// }

export function encodeMultiAddressInfo(indexes: number[], configure = false) {
  indexes = indexes.sort(ASCENDING_SORT_NUMBER);
  const firstIndex = indexes[0];
  const lastIndex = indexes[indexes.length - 1];
  const length = lastIndex - firstIndex + 1;
  return {
    address: (configure ? CONFIGURE_MASK : 0) | firstIndex,
    format: DIRECT_ACCESS_GPIO_FORMAT,
    length,
  };
}

export function encodeMultiIndexData(
  indexValues: { index: number; value: number | boolean }[],
) {
  const indexes = indexValues.map((v) => v.index).sort(ASCENDING_SORT_NUMBER);
  const firstIndex = indexes[0];
  const data: number[] = [];
  const lastIndex = indexes[indexes.length - 1];
  for (
    let pinIndex = firstIndex, loopIndex = 0;
    pinIndex <= lastIndex;
    pinIndex++, loopIndex++
  ) {
    const indexValue = indexValues.find((v) => v.index == pinIndex);
    if (indexValue) {
      data[loopIndex] =
        indexValue.value === true
          ? 1
          : indexValue.value === false
            ? 0
            : indexValue.value;
    } else {
      data[loopIndex] = 0xff;
    }
  }
  return Uint8Array.from(data);
}

// export function encodeMultiGPIOData(indexes: number[], value: number): Uint8Array {
//     indexes = indexes.sort(ASCENDING_SORT_NUMBER);
//     const firstIndex = indexes[0];
//     const data: number[] = [];
//     const lastIndex = indexes[indexes.length - 1];
//     for (let pinIndex = firstIndex, loopIndex = 0; pinIndex <= lastIndex; pinIndex++, loopIndex++) {
//         if (indexes.indexOf(pinIndex) >= 0) {
//             data[loopIndex] = value;
//         }
//         else {
//             data[loopIndex] = 0xFF;
//         }
//     }
//     return Uint8Array.from(data);
// }
